import LoyaltyProgramFab from "./LoyaltyProgramFab";
import LoyaltyProgramModal from "./LoyaltyProgramModal";
import {
  closeLoyaltyProgramModal,
  openLoyaltyProgramModal,
} from "../../redux/slices/loyaltyModalSlice";
import { useDispatch, useSelector } from "react-redux";

const LoyaltyProgramModule = () => {
  const dispatch = useDispatch();
  const modalState = useSelector((state) => state.loyaltyModalData);

  return (
    <>
      <LoyaltyProgramFab
        onClick={() => dispatch(openLoyaltyProgramModal())}
        active={!modalState}
      />
      <LoyaltyProgramModal
        closeModal={() => dispatch(closeLoyaltyProgramModal())}
        active={modalState}
      />
    </>
  );
};

export default LoyaltyProgramModule;
